import {
  moduleId,
  ModuleId,
  moduleName,
  ModuleName,
} from '@edgvr-front/modules/domain';
import {
  DataModuleType,
  DataScore,
  DataSpecificJsonData,
  DataModuleVORaw as DataModuleVORaw0,
} from '../interface';
import {
  dataModuleType,
  dataScore,
  nullableDataSpecificJsonData,
} from '../schema';
import { DataPersonVO } from './DataPersonVO';
import { Validate } from '@edgvr-front/util/validate';

export class DataModuleVO {
  private static validation = Validate.compile(
    DataModuleVO.validationSchema(),
    DataPersonVO
  );

  constructor(private readonly value: DataModuleVORaw) {
    Validate.assert(DataModuleVO.validation, this.value);
  }

  get id() {
    return this.value.Id;
  }

  get moduleName() {
    return this.value.ModuleName;
  }

  get moduleType() {
    return this.value.ModuleType;
  }

  get persons() {
    return this.value.People;
  }

  get personsCount() {
    return this.value.People.length;
  }

  get maxScore() {
    return this.value.MaxScore;
  }

  get specificJSONData() {
    return this.value.SpecificJSONData;
  }

  get isPollution() {
    return this.moduleType.toLowerCase() === 'pollution';
  }

  toJSON() {
    return {
      ...this.value,
      People: this.value.People.map((_) => _.toJSON()),
    };
  }

  static factory(dataModuleVORaw: DataModuleVORaw0) {
    return new DataModuleVO({
      ...dataModuleVORaw,
      People: dataModuleVORaw.People.map((_) => new DataPersonVO(_)),
    });
  }

  private static validationSchema() {
    return {
      type: 'object',
      required: [
        'Id',
        'ModuleName',
        'ModuleType',
        'MaxScore',
        'People',
        'SpecificJSONData',
      ],
      properties: {
        Id: moduleId,
        ModuleName: moduleName,
        ModuleType: dataModuleType,
        MaxScore: dataScore,
        People: {
          type: 'array',
          items: {
            instanceof: DataPersonVO.name,
          },
        },
        SpecificJSONData: nullableDataSpecificJsonData,
      },
    };
  }
}

interface DataModuleVORaw {
  Id: ModuleId;
  ModuleName: ModuleName;
  ModuleType: DataModuleType;
  MaxScore: DataScore;
  People: DataPersonVO[];
  SpecificJSONData: null | DataSpecificJsonData;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: any;
}
